import { render, staticRenderFns } from "./orderRank.vue?vue&type=template&id=13f593f1&scoped=true&"
import script from "./orderRank.vue?vue&type=script&lang=js&"
export * from "./orderRank.vue?vue&type=script&lang=js&"
import style0 from "./orderRank.vue?vue&type=style&index=0&id=13f593f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f593f1",
  null
  
)

export default component.exports